import React from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";
import { PopoverModal } from "../../../../../components/popoverModal/PopoverModal";

export function useTabIndicacionColumns(
  handleOpenDeleteDialog,
  handleOpenEditDialog,
  handleOpenViewDialog,
  allowedWrite,
  indicacioneComerciales
) {

  const initialColumns = [
    {
      headerName: "",
      field: "action",
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <PopoverModal>
            <div className="popover-modal-content">
              <>
                <div
                  aria-hidden="true"
                  onClick={() => handleOpenViewDialog(row)}
                  className="item-option clickable-option"
                >
                  <VisibilityIcon className="edit-icon" />
                  <span className="toggle-action">Ver</span>
                </div>
              </>
              {(allowedWrite) && (row.solicitudEnCurso == 0) &&
                <div
                  aria-hidden="true"
                  onClick={() => handleOpenEditDialog(row)}
                  className="item-option clickable-option"
                >
                  <EditIcon className="edit-icon" />
                  <span className="toggle-action">Editar</span>
                </div>
              }
              {(allowedWrite) && !indicacioneComerciales?.some(x => x.idInsumo === row?.idInsumo) &&
                <div
                  aria-hidden="true"
                  onClick={() => handleOpenDeleteDialog(row.idIndicacion)}
                  className="item-option clickable-option"
                >
                  <DeleteOutlinedIcon className="edit-icon" />
                  <span className="toggle-action">Eliminar</span>
                </div>
              }
            </div>
          </PopoverModal>
        );
      },
    },
    {
      flex: 0.05,
      field: "idIndicacion",
      headerName: "#",
    },
    {
      flex: 0.2,
      field: "fechaDesde",
      headerName: "Fecha desde",
      headerAlign: 'center',
      align: 'center',
      type: "date",
    },
    {
      flex: 0.2,
      field: "fechaHasta",
      headerName: "Fecha hasta",
      type: "date",
    },
    {
      flex: 0.3,
      field: "fechaAlta",
      headerName: "Fecha alta",
      headerAlign: 'right',
      align: 'right',
      type: "date",
    }
  ].filter(Boolean);

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
